export default __webpack_public_path__ + "static/media/recurring-img2.8041cd1b.png";